module.exports = __webpack_public_path__ + "static/img/COC2021-23.0522338.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-23.jpg
// module id = c48x
// module chunks = 0